import React, { useEffect, useState } from "react";
import fogg from "../../images/landingPage/4.svg";
import online from "../../images/landingPage/online.svg";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  getAllHomeCertification,
  getAllHomeTrainings,
} from "../../actions/home/home_action";
import LoadingOverlay from "react-loading-overlay";
import { Button } from "react-bootstrap";
import { Modal } from "react-bootstrap";
import { redirectUser } from "../../config/redirect";
import Carousel from "react-elastic-carousel";
import { useRef } from "react";
import Footer from "../components/Footer";
import HomeNavBar from "../components/HomeNavBar";
import CourseShowModal from "./CourseShowModal";
import CertificationShowModal from "./CertificationShowModal";
import { addElementToCart } from "../../actions/home/cart_action";
import { ToastContainer, toast } from "react-toastify";
const TraningLandingPage = () => {
  const state = useSelector((state) => state.homeReducer);
  const cartState = useSelector((state) => state.cartReducer);
  const dispatch = useDispatch();
  const [courseData, setCourseData] = useState({});
  const [courseModal, setCourseModal] = useState(false);
  const navigate = useNavigate();
  const [certificationData, setCertificationData] = useState({});
  const [certificationModal, setCertificationModal] = useState(false);

  useEffect(() => {
    dispatch(getAllHomeTrainings());
    //  dispatch(getAllHomeCertification());
  }, []);

  const [show, setShow] = useState({
    show: false,
    data: {},
  });
  const handleClose = () => {
    setShow({ show: false, data: {} });
  };
  const handleShow = (li) => {
    setShow({ show: true, data: li });
  };

  const breakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 550, itemsToShow: 2, itemsToScroll: 2 },
    { width: 768, itemsToShow: 3 },
    { width: 1200, itemsToShow: 4 },
  ];

  const itemsPerPage = 3;
  const items = [];
  const carouselRef = useRef(null);
  const totalPages = Math.ceil(items.length / itemsPerPage);
  let resetTimeout;

  if (localStorage.getItem("token")) {
    return <Navigate to={redirectUser()} />;
  }

  //
  const courseContentData = (li) => {
    setCourseModal(true);
    setCourseData(li);
  };
  const resetCourseData = () => {
    setCourseModal(false);
    setCourseData({});
  };

  const certificationContentData = (li) => {
    setCertificationModal(true);
    setCertificationData(li);
  };

  const resetCertificationData = () => {
    setCertificationModal(false);
    setCertificationData({});
  };

  const deviceKey = localStorage.getItem("uu");
  const addToCart = (data, type) => {
    dispatch(
      addElementToCart({
        type: type,
        type_id: data.id,
        price: data.cost_doller,
        device_key: deviceKey,
      })
    );
  };

  if (cartState.is_done) {
    toast("Item Added Into Cart!", {
      type: "success",
      position: "top-center",
    });
  }

  const getMoreDetails = (id) => {
    navigate("/certification-details/" + window.btoa(id));
  };

  const registerStudent = (slug) => {
    navigate("/training-register/" + slug);
  };

  return (
    <LoadingOverlay active={state.loading} spinner text="Loading...">
      <div className="main-landing-page traning-landing-page landing-container">
        {/* navbar */}
        <HomeNavBar />
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12 col-lg-6">
              <div className="top-hedtxt-section">
                <h4 className="hed-txt">Training Solutions</h4>
                <p className="first-title">
                  Take the first step
                  <br></br>
                  to learn with us
                </p>
                <p className="banner-des">
                  We are the one stop shop for all your training needs. We as
                  your IT training and consulting partner can support both older
                  and newer technology, and also assist you to figure out how to
                  integrate them. With our battery of trainers, we support all
                  your endeavours and infuse confidence in your workforces’
                  human assets so that they can soar HIGH.
                </p>
                <a href="#." className="banner-btn">
                  Enroll for Free
                </a>
              </div>
            </div>
            <div className="col-sm-12 col-lg-6">
              <div className="top-banner pt-4">
                <img src={fogg} />
              </div>
            </div>
          </div>
          <ToastContainer />
          {state.list && state.list.length > 0 && (
            <div>
              <div className="row cource-section">
                <div className="col-12">
                  <div className="titlepage">
                    <h4>Browse Our Top Trending Courses</h4>
                  </div>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-5 search-grp">
                  <input
                    type="text"
                    className="form-control serach-text-home"
                  />
                  <button className="search-btn btn-common" type="button">
                    <i class="fa fa-search"></i>
                  </button>
                </div>
                <Link to={"/courses"} className="mr-link">
                  More Courses <i class="fa-solid fa-arrow-right"></i>
                </Link>
              </div>

              <div className="row cource-section">
                <div className="col-12 carousel-section">
                  <Carousel
                    breakPoints={breakPoints}
                    enableAutoPlay
                    autoPlaySpeed={1500} // same time
                    onNextEnd={({ index }) => {
                      clearTimeout(resetTimeout);
                      if (index + 1 === totalPages) {
                        resetTimeout = setTimeout(() => {
                          carouselRef.current.goTo(0);
                        }, 1500); // same time
                      }
                    }}
                  >
                    {state.list.map((li, i) => (
                      <div>
                        <div className="box">
                          <div className="row">
                            <div className="col-xs-12 col-12">
                              <h4 className="title certification-nm">
                                <span className="certification-nm">
                                  {li.name + "    "}
                                </span>
                              </h4>
                              {/*<p className="course-count">10+ Courses</p>*/}
                            </div>

                            <br />
                            <div className="col-xs-10 col-10">
                              <h6 className="cer-details">
                                {li.start_date} To {li.end_date}{" "}
                              </h6>
                            </div>
                            <div className="col-xs-2 col-2 mb-3">
                              <button
                                onClick={() => registerStudent(li.slug)}
                                className="btn-common cert-btns f-right"
                                title="Register To Training"
                              >
                                Register{" "}
                              </button>
                            </div>
                            <br />

                            <div className="col-xs-6 col-6">
                              <p className="cer-details" contentEditable="true">
                                {"HTML,CSS,BOOTSTRAP,Javascript,SQL,"}
                              </p>
                            </div>

                            <div className="col-xs-6 col-6 align-c">
                              <img
                                className=""
                                src={online}
                                alt="First slide"
                              />
                            </div>
                            <div className="col-5">
                              <button
                                onClick={() => addToCart(li, "is_course")}
                                className="btn-common cert-btns"
                                title="Add to cart"
                              >
                                Add{" "}
                                <i
                                  class="fa fa-shopping-cart btn-cart"
                                  aria-hidden="true"
                                ></i>
                              </button>
                            </div>

                            <div className="col-7  align-r">
                              <a
                                className="mr-14"
                                onClick={() => courseContentData(li)}
                              >
                                Course Content
                              </a>{" "}
                              <br />
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </Carousel>
                </div>
              </div>
            </div>
          )}

          {/*
          {state.courses && state.courses.length > 0 && (
            <div>
              <div className="row cource-section">
                <div className="col-12">
                  <div className="titlepage">
                    <h4>Browse Our Top Trending Courses</h4>
                  </div>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-5 search-grp">
                  <input
                    type="text"
                    className="form-control serach-text-home"
                  />
                  <button className="search-btn btn-common" type="button">
                    <i class="fa fa-search"></i>
                  </button>
                </div>
                <Link to={"/courses"} className="mr-link">
                  More Courses <i class="fa-solid fa-arrow-right"></i>
                </Link>
              </div>

              <div className="row cource-section">
                <div className="col-12 carousel-section">
                  <Carousel
                    breakPoints={breakPoints}
                    enableAutoPlay
                    autoPlaySpeed={1500} // same time
                    onNextEnd={({ index }) => {
                      clearTimeout(resetTimeout);
                      if (index + 1 === totalPages) {
                        resetTimeout = setTimeout(() => {
                          carouselRef.current.goTo(0);
                        }, 1500); // same time
                      }
                    }}
                  >
                    {state.courses.map((li, i) => (
                      <div>
                        <div className="box">
                          <div className="row">
                            <div className="col-xs-8 col-8">
                              <h4 className="title certification-nm">
                                <span className="certification-nm">
                                  {li.name}
                                </span>
                              </h4>
                              
                            </div>
                            <div className="col-xs-4 col-4">
                              <button
                                onClick={() => registerStudent(li.slug)}
                                className="btn-common cert-btns f-right"
                                title="Register To Training"
                              >
                                Register{" "}
                              </button>
                            </div>
                            <br />
                            <div className="col-xs-6 col-6">
                              <h6 className="cer-details">Category</h6>
                              <h6 className="cer-details">{li.level}</h6>
                              <h6 className="cer-details">
                                {li.duration + " " + li.duration_type}
                              </h6>
                            </div>

                            <div className="col-xs-6 col-6 align-c">
                              <img
                                className=""
                                src={online}
                                alt="First slide"
                              />
                            </div>
                            <div className="col-5">
                              <button
                                onClick={() => addToCart(li, "is_course")}
                                className="btn-common cert-btns"
                                title="Add to cart"
                              >
                                Add{" "}
                                <i
                                  class="fa fa-shopping-cart btn-cart"
                                  aria-hidden="true"
                                ></i>
                              </button>
                            </div>

                            <div className="col-7  align-r">
                              <a
                                className="mr-14"
                                onClick={() => courseContentData(li)}
                              >
                                Course Content
                              </a>{" "}
                              <br />
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </Carousel>
                </div>
              </div>
            </div>
                    )}  */}

          {state.certifications && state.certifications.length > 0 && (
            <div>
              <div className="row cource-section">
                <div className="col-12">
                  <div className="titlepage">
                    <h4>Browse Our Top Trending Courses</h4>
                  </div>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-5 search-grp">
                  <input
                    type="text"
                    className="form-control serach-text-home"
                  />
                  <button className="search-btn btn-common" type="button">
                    <i class="fa fa-search"></i>
                  </button>
                </div>
                <Link to={"/certifications"} className="mr-link">
                  More Certifications <i class="fa-solid fa-arrow-right"></i>
                </Link>
              </div>

              <div className="row cource-section">
                <div className="col-12 carousel-section">
                  <Carousel
                    breakPoints={breakPoints}
                    enableAutoPlay
                    autoPlaySpeed={1500} // same time
                    onNextEnd={({ index }) => {
                      clearTimeout(resetTimeout);
                      if (index + 1 === totalPages) {
                        resetTimeout = setTimeout(() => {
                          carouselRef.current.goTo(0);
                        }, 1500); // same time
                      }
                    }}
                  >
                    {state.certifications.map((li, i) => (
                      <div>
                        <div className="box">
                          <div className="row">
                            <div className="col-xs-12 col-12">
                              <h4 className="title certification-nm">
                                <i
                                  className={
                                    li.certification_type === "AWS"
                                      ? "fa fa-aws cert-icon"
                                      : li.certification_type === "Google"
                                      ? "fa fa-google cert-icon"
                                      : "fa fa-microsoft cert-icon"
                                  }
                                ></i>
                                <span className="certification-nm">
                                  {li.name}
                                </span>
                              </h4>
                              {/*<p className="course-count">10+ Courses</p>*/}
                            </div>
                            <br />

                            <div className={"cer-btn-div col-12"}>
                              <button className="btn-common cert-btns">
                                Live
                              </button>
                              <br />
                              <button className="btn-common cert-btns">
                                Videos
                              </button>
                              <br />
                              <button className="btn-common cert-btns">
                                Request
                              </button>
                            </div>
                            <br />
                            <div className="col-lg-6">
                              <button
                                title={"See More Details"}
                                className="btn-common cert-btns"
                                onClick={() => getMoreDetails(li.id)}
                              >
                                More Details
                              </button>
                              <button
                                title="Add to cart"
                                className="btn-common cert-btns"
                                onClick={() => addToCart(li, "is_certificate")}
                              >
                                <i
                                  class="fa fa-shopping-cart btn-cart"
                                  aria-hidden="true"
                                ></i>
                              </button>
                            </div>
                            <div className="col-lg-6">
                              <span className="cert-price">
                                ${li.cost_doller}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </Carousel>
                </div>
              </div>
            </div>
          )}
        </div>
        {/* footer */}
        <Footer />
      </div>

      <Modal
        className="course-modal"
        size="lg"
        onHide={handleClose}
        show={show.show}
      >
        <Modal.Header>
          <Modal.Title>
            <h4 className="course-ttl">{show.data.name}</h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div class="paths-content-description">
            <p>{show.data.description}</p>
            <div class="paths-content-highlight paths-aside-box show-for-large-up">
              <div class="paths-aside-scrollable">
                <h3>What you will learn</h3>
                <ul>
                  <li>Angular core concepts</li>
                  <li>Angular CLI</li>
                  <li>Forms</li>
                </ul>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="row">
            <div className="col-6 text-left pl-0">
              <Link
                to={"/training/" + show.data.slug}
                className="banner-btn posts-btn btn-common"
              >
                Enroll
              </Link>
            </div>
            <div className="col-6 text-right">
              <Button variant="outline-info" onClick={handleClose}>
                Close
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      {courseModal && (
        <CourseShowModal
          show={courseModal}
          courseData={courseData}
          handelCloseShow={() => resetCourseData()}
        />
      )}

      {certificationModal && (
        <CertificationShowModal
          show={certificationModal}
          certificationData={certificationData}
          handelCloseShow={() => resetCertificationData()}
        />
      )}
    </LoadingOverlay>
  );
};
export default TraningLandingPage;
